import { Injectable } from '@angular/core';
import { ResourceService } from './resource.service';
import * as Constants from '../globals/constants';
import { Helper } from '../utilities/helper';

@Injectable({
  providedIn: 'root'
})
export class AscensionService {

  private helper = new Helper();
  public STATE;
  public UI_ASCENSION;
  private resourceService: ResourceService;

  constructor(resourceService: ResourceService) {
    this.resourceService = resourceService;
    this.STATE = this.helper.deepCopyObject(Constants.ASCENSION_STATE);
    Constants.SINGLETON_ASCENSION.STATE = this.STATE;
    this.UI_ASCENSION = Object.entries(Constants.ASCENSION);
  }

  public get state() {
    return this.STATE;
  }

  public meetsTechRequirements(technology) {
    if ( Constants.ASCENSION[technology].ascension_requirements.length === 0 ) {
      return true;
    } else {
      let canResearch = true;
      Constants.ASCENSION[technology].ascension_requirements.forEach((requirement) => {
        if (!this.STATE.unlocked[requirement]) {
          canResearch = false;
        }
      });
      return canResearch;
    }
  }

  public research(tech) {
    if (Constants.ASCENSION[tech].costs <= this.STATE.ascension_points) {
      this.STATE.ascension_points -= Constants.ASCENSION[tech].costs;
      this.STATE.unlocked[tech] = true;
      Constants.SINGLETON_ASCENSION.STATE = this.STATE;
    }
  }

  public reset(hardReset = false) {
    if (hardReset) {
      this.STATE = this.helper.deepCopyObject(Constants.ASCENSION_STATE);
    }
    // this.STATE = this.helper.deepCopyObject(Constants.TECH_STATE);
    Constants.SINGLETON_ASCENSION.STATE = this.STATE;
  }

  public addAscensionPoints(amount: number) {
    this.state.ascension_points += amount;
    this.state.total_ascension_points += amount;
  }

  public ascend() {
    this.state.times_ascended++;
    this.state.ascension_level = this.state.times_ascended;
    this.addAscensionPoints(this.state.times_ascended); // this.state.times_ascended;
    if (this.state.unlocked.ascension_knowledge) {
      this.addAscensionPoints(1);
    }
    this.state.isAscending = true;
  }
}
